module.exports = __webpack_public_path__ + "img/Delete.c11a8348.svg";